import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Log from '../../models/Log'

export interface LogListState extends PaginatedApiState {
  logs?: Log[]
}

const LogList = (state: LogListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<LogListState>('LOG_LIST')(state, action)
  }
}

export default LogList
